var _circle, _circle2, _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlexiCancellation = function SvgFlexiCancellation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.314,
    r: 16,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "FlexiCancellation_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.314,
    r: 16,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlexiCancellation_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24 14.983a4.183 4.183 0 0 1 2.987-1.259h6.755v-2.633c0-.686.836-1.026 1.335-.567l7.4 6.063a.768.768 0 0 1-.01 1.198l-7.424 6.084c-.52.426-1.301.051-1.3-.595V20.64h-4.171v19.674H6V18.017c0-1.183.475-2.257 1.24-3.034Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "FlexiCancellation_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 10,
    width: 20,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24 14.983a4.183 4.183 0 0 1 2.987-1.259h6.755v-2.633c0-.686.836-1.026 1.335-.567l7.4 6.063a.768.768 0 0 1-.01 1.198l-7.424 6.084c-.52.426-1.301.051-1.3-.595V20.64h-4.171v19.674H6V18.017c0-1.183.475-2.257 1.24-3.034Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlexiCancellation_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.113 17.586a4.183 4.183 0 0 1 2.987-1.26h6.755v-2.633c0-.685.836-1.026 1.335-.567l7.4 6.064a.768.768 0 0 1-.01 1.197l-7.424 6.084c-.52.426-1.3.052-1.3-.595v-2.633h-4.171v19.673H6.873V20.62c0-1.183.475-2.256 1.24-3.033Z",
    fill: "#F9AD78"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 39.814h5.812V20.14h5.17v3.134c0 .215.283.373.484.208l7.425-6.084.005-.004a.268.268 0 0 0 .004-.42L18 10.91l-.011-.01-.01-.01a.297.297 0 0 0-.324-.052.263.263 0 0 0-.173.252v3.133h-7.255a3.683 3.683 0 0 0-2.631 1.11A3.814 3.814 0 0 0 6.5 18.017v21.797Z",
    stroke: "#222"
  }))));
};
export default SvgFlexiCancellation;